import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import classNames from 'classnames';
import HelpLink from 'App/HelpLink/HelpLink';
import useNavegate from 'App/hooks/useNavegate';
import { IonPageStratus, useResponsive } from 'commons/components';
import { CAN_LINK_ABOUT_ORDERS } from 'commons/constants/externalLinks';
import { useTranslationLanguage } from 'commons/hooks';
import { DRAFT_ORDERS_ROUTES } from 'domains/Orders/DraftOrders/draftOrdersRoutes';
import { trackingOrderDraftOrderCreateClick } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import emptyOrders from './empty-orders.png';
import './OrderListEmpty.scss';

export function OrderListEmpty() {
  const t = useTranslationOrders();
  const language = useTranslationLanguage();
  const { goTo } = useNavegate();
  const { isMobile } = useResponsive();

  const onClickAddOrder = () => {
    trackingOrderDraftOrderCreateClick();
    goTo(DRAFT_ORDERS_ROUTES.newDraftOrder);
  };

  const className = classNames('stratus--orders-list-empty-text-color', {
    'stratus--orders-list-empty-center-text': isMobile,
  });

  return (
    <IonPageStratus width="medium">
      <InitialScreen>
        <div className={className}>
          <InitialScreen.Hero
            subtitle={t('emptyOrdersList.ordersTitle').toUpperCase()}
            title={t('emptyOrdersList.title')}
            description={t('emptyOrdersList.body')}
            image={
              <img
                width={isMobile ? '198px' : '100%'}
                height={isMobile ? '198px' : '100%'}
                src={emptyOrders}
                alt={t('emptyOrdersList.title')}
              />
            }
            actions={
              <Button onClick={onClickAddOrder} appearance="primary">
                {t('emptyOrdersList.actionPrimary')}
              </Button>
            }
          />
          <Box
            display="flex"
            flexDirection="row"
            gap="2"
            justifyContent="center"
            mt="5"
            paddingTop="5"
          >
            <HelpLink
              title={t('helpText')}
              linkURL={CAN_LINK_ABOUT_ORDERS[language]}
              previousValue=""
              currentViewTracking={t('helpText')}
              icon="both"
              showInMobile
            />
          </Box>
        </div>
      </InitialScreen>
    </IonPageStratus>
  );
}
